import React, { Component } from 'react'
import UserManager from './UserManager';
import MainInfo from './MainInfo';
import Compliance from './Compliance';
import ComplianceDetails from './ComplianceDetails';

export class RemoteCompliance extends Component {

    constructor(props){
        super(props);
        
        var generalInfo = props.info;

        var codeInfo = generalInfo.type;
        var mainCode = generalInfo.maincode;
        
        var eventInfo = [];
        eventInfo.eventDate = generalInfo.details.date;
        eventInfo.clubName = generalInfo.details.place;
        eventInfo.eventName = generalInfo.details.name;
        eventInfo.hours = generalInfo.details.hours;
        eventInfo.hour = generalInfo.details.hour;
        eventInfo.dates = generalInfo.details.dates;
        eventInfo.eventDateArray = generalInfo.details.dateArray;

        var bookingInfo = null;
        if(props.booking!=null && codeInfo==='remote'){
            bookingInfo = props.booking;
        }

        var loginInfo = generalInfo.login;
    
        this.state = { userInfo: props.user, bookingInfo: bookingInfo, eventInfo: eventInfo, type: codeInfo, mainCode: mainCode, loginInfo: loginInfo};
        
      }


      confirmAccess = (e) => {
          
        var sessiontoken = localStorage.getItem('session_token');
        if(sessiontoken === null){
            sessiontoken = '';
        }
    
    const requestOptions = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
      body: JSON.stringify({
                code: this.state.userInfo.token,
                token: sessiontoken
              })
      };
    
          const apiUrl = 'https://getfy-business.com/user/v5/compliance/';

    fetch(apiUrl, requestOptions)
    .then(r => r.json())
    .then(r => {

        window.location.reload();
      
    }).catch(e => {
        window.location.reload();
    });

      }


    render() {
        return (
            <div>
                 <MainInfo info={this.state.eventInfo} />


                 {
                   this.state.bookingInfo === null && this.state.userInfo !== null && this.state.userInfo.birth === 'ok' && this.state.userInfo.sex === 'ok'
                   ? (
                    <Compliance confirmAccess={this.confirmAccess} user={this.state.userInfo} />
                   )
                   : (
                       null
                   )
                }

                {
                   this.state.bookingInfo !== null && this.state.userInfo !== null && this.state.userInfo.birth === 'ok' && this.state.userInfo.sex === 'ok'
                   ? (
                    <ComplianceDetails info={this.state.bookingInfo} user={this.state.userInfo}  />
                   )
                   : (
                       null
                   )
                }

                 {
                   this.state.userInfo === null || (this.state.userInfo !== null && (this.state.userInfo.birth !== 'ok' || this.state.userInfo.sex !== 'ok'))
                   ? (
                    <UserManager loginInfo={this.state.loginInfo} user={this.state.userInfo} /> 
                   )
                   : (
                       null
                   )
               }



            </div>
        )
    }
}

export default RemoteCompliance
